import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'red-custom-layout',
  templateUrl: './custom-layout.component.html',
  styleUrls: ['./custom-layout.component.scss']
})
export class CustomLayoutComponent implements OnInit {
  constructor() { }

  ngOnInit() {
  }
}
